import { useEffect, useRef } from 'react';
import WebCarouselAdEdit from './WebCarouselAdEdit';
import WebCarouselAdFileEdit from './WebCarouselAdFileEdit';
import WebUniversal, { WebUniversalProps } from '../../system/WebUniversal';
import { columnsheadId } from '../../universal/columnshead';
import dayjs from 'dayjs';
import { Image } from 'antd';
import fetchApi from '../../../utilsTsx/components/system/fetchApi';

//组件 
const WebCarouselAd = (props: any) => {
    const apiId = 'webCarouselAd';
    const ref = useRef<any>(undefined);

    useEffect(() => {
    }, []);

    //表头
    const columnsHead = [
        {
            title: '名称',
            dataIndex: 'adName',
            sorter: true,
        },
        {
            title: '类型',
            dataIndex: 'carouselAdType_Name',
        },
        {
            title: '开始时间',
            dataIndex: 'startTime',
            render: (val: any) => <span>{dayjs(val).format('YYYY-MM-DD')}</span>,
        },
        {
            title: '结束时间',
            dataIndex: 'endTime',
            render: (val: any) => <span>{dayjs(val).format('YYYY-MM-DD')}</span>,
        },
        {
            title: '剩余数',
            dataIndex: 'remainingShows',
            sorter: true,
        },
        {
            title: '显示模式',
            dataIndex: 'adShowModel_Name',
            sorter: true,
        },
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);


    //表头
    const filesColumns = [
        {
            title: '广告',
            dataIndex: 'carouselAd',
            render: (text: any) => (text.adName)
        },
        {
            title: '产品',
            dataIndex: 'product',
            render: (text: any) =>
                (text ? text.productName : '')
        },
        {
            title: '图片',
            dataIndex: 'id',
            render: (text: any, record: any) => (
                < Image
                    src={`${record.serverUrl}/${record.fileDestination}`}
                    width={60}
                    alt="图片" />
            )
        }
    ];

    let extendProps: WebUniversalProps = {
        ...props,
        titleName: '图片广告',
        apiId,
        columns,
        EditComponent: WebCarouselAdEdit,
        displayOptions: {
            showFiles: true
        },
        filesOptions: {
            FilesEditComponent: WebCarouselAdFileEdit,
            filesColumns,
            fileParentId: 'carouselAdId',
            insertFile: async (payload) => {
                const { sendPageData, fileRows } = payload;
                for (const item of fileRows) {
                    const insertRes = await fetchApi.POST(ref.current?.defaultService,
                        {
                            body: {
                                apiId: `${apiId}File`,
                                apiData: {
                                    [`${apiId}Id`]: sendPageData.carouselAdId,
                                    serverUrl: item.serverUrl,
                                    fileId: item.id,
                                    fileDestination: `${item.destination}/${item.fileName}`,
                                    fileType: item.fileType,
                                    fileSize: item.fileSize,
                                    imageWidth: item.imageWidth,
                                    imageHeight: item.imageHeight,
                                    isDefault: false,
                                    isUse: true
                                }
                            }
                        })
                }
                return { success: true };
            },
        },
    };

    return (
        <>
            <WebUniversal {...extendProps} ref={ref} />
        </>
    )
}

export default WebCarouselAd;